module.exports = __webpack_public_path__ + "img/PD1503921292523474944.6c5fdecc.png";